import { globalAppConfig } from "app/configs/global-app-config";
import {
  MarApiResponse,
  AddressResult,
} from "../@types/interfaces/mar-api.interface";

export const buildSearchUrl = (address: string): string => {
  const encodedAddress = encodeURIComponent(address);
  return `${globalAppConfig.marApiBaseUrl}${globalAppConfig.marApiSearchPath}/${encodedAddress}`;
};

export const hasRejectionCharacters = (address: string): boolean => {
  return globalAppConfig.marApiRejectionCharacters
    .split("")
    .some((char) => address.includes(char));
};

export const transformMarResponse = (
  marResponse: MarApiResponse
): AddressResult[] => {
  if (!marResponse.Success) {
    return [];
  }

  return marResponse.Result.addresses.map((item) => {
    let locationType = "Address";

    if (item.address.properties.BlockKey && !item.address.properties.AddrNum) {
      locationType = "Block";
    }

    return {
      fullAddress: item.address.properties.FullAddress,
      locationType: locationType,
      ward: item.address.properties.Ward,
      zipcode: item.address.properties.Zipcode,
      latitude: item.address.properties.Latitude,
      longitude: item.address.properties.Longitude,
      marId: item.address.properties.MarId,
      quadrant: item.address.properties.Quadrant,
    };
  });
};

export const buildSearchString = (
  streetNumber: string,
  streetName: string,
  quadrant: string
): string => {
  return `${streetNumber} ${streetName} ${quadrant}`.trim();
};
